import { profileEditionByType } from "views/Config/Rules/ProfMenuItem";

export const VIEW = "viewRulesRate";

export const POLI = {
  attr: "poli",
  type: "policy",
  cmdRespColIdx: 9,
  titleEdit: "Policy",
  header: "POLICY",
};

export const PROFS = [
  {
    attr: "if",
    cmdRespColIdx: 2,
    type: "interface",
    titleEdit: "Interface Profile",
    header: "INTERFACE",
  },
  {
    attr: "vlan",
    cmdRespColIdx: 3,
    type: "vlan",
    titleEdit: "VLAN Profile",
    header: "VLAN",
  },
  {
    attr: "subscriberGroup",
    cmdRespColIdx: 4,
    type: "subscriber-group",
    titleEdit: "Subscriber Group Profile",
    header: "SUB-GROUP",
  },
  {
    attr: "subscriberId",
    cmdRespColIdx: 5,
    type: "subscriber-id",
    titleEdit: "Subscriber ID Profile",
    header: "SUB-ID",
  },
  {
    attr: "acc",
    cmdRespColIdx: 6,
    type: "access",
    titleEdit: "Access Profile",
    header: "ACCESS",
  },
  {
    attr: "time",
    cmdRespColIdx: 7,
    type: "time",
    titleEdit: "Time Profile",
    header: "TIME",
  },
  // TEMPORARY Disabled
  // {
  //   attr: "throu",
  //   cmdRespColIdx: 10,
  //   type: "throughput",
  //   titleEdit: "Throughput Profile",
  //   header: "THROUGHPUT",
  // },
  // {
  //   attr: "poli",
  //   cmdRespColIdx: 9,
  //   type: "policy",
  //   titleEdit: "Policy Profile",
  //   header: "POLICY",
  // },
];

export const TYPE_PROFILE_SHORTCUTF_MAP = {
  ...profileEditionByType(PROFS),
  policy: function (poliName, viewName, tab) {
    globalNavigate("viewPolicyRateEdit", {returnView: viewName, policy: poliName, tab: tab?.tab});
  },
};
